var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regular-menu d-none d-xl-flex justify-content-center align-items-center text-nowrap"},_vm._l((_vm.topMenu.items),function(ref){
var label = ref.label;
var href = ref.href;
var target = ref.target;
var items = ref.items;
var htmlClass = ref.htmlClass;
return _c('RegularMenuItem',{key:label,class:htmlClass,attrs:{"label":label,"href":href,"target":target,"children":items}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }